import {Controller} from "@hotwired/stimulus";
// import {Turbo} from "@hotwired/turbo-rails";


/**
 * Promote a visit when it's added to the DOM,
 * meant to be as a TurboStream response from the server
 *
 * This controller will self destruct
 */
export default class ThemeController extends Controller {
  initialize() {
    console.debug("THEME initialized");

    this.onThemeChangedListener = this.onThemeChanged.bind(this);
    this.theme = this.preferredTheme;
    this.element.classList.remove('opacity-0');
  }

  connect() {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', this.onThemeChangedListener);
  }

  disconnect() {
    window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', this.onThemeChangedListener);
  }

  onThemeChanged() {
    console.debug("THEME chenged", this);
    // if (storedTheme !== 'light' || storedTheme !== 'dark') {
    this.theme = this.preferredTheme;
    // }
  }

  get storedTheme() {
    localStorage.getItem('theme');
  }

  set theme(theme) {
    if (theme === 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      document.documentElement.setAttribute('data-bs-theme', 'dark')
    } else {
      document.documentElement.setAttribute('data-bs-theme', theme)
    }
  }

  get preferredTheme() {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
}
